import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setShouldDisplayAlternativeOffers} from 'modules/accommodation/slice'
import {getIsAlternativeOffersOverlayOpen} from 'modules/alternativeOffers/selectors'
import {
  getSearchParametersCheckIn,
  getSearchParametersCheckOut,
  getSearchParametersRooms
} from 'modules/sapiSearch/selectors'

import {trackEvent} from '@daedalus/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity
} from '@daedalus/core/src/analytics/types/Events'
import {AlternativeOffersOverlay} from '@daedalus/shared/src/booking/AlternativeOffersOverlay'
import {ContentHotel} from '@findhotel/sapi/dist/types/packages/core/src/types/types'

import {AlternativeOffersListContainer} from './AlternativeOffersListContainer'
import {HotelCardInfoContainer} from './HotelCardContainer'

export const RoomsAlternativeOffers = ({hotel}: {hotel: ContentHotel}) => {
  const isAlternativeOffersOverlayOpen = useSelector(
    getIsAlternativeOffersOverlayOpen
  )

  const checkIn = useSelector(getSearchParametersCheckIn)
  const checkOut = useSelector(getSearchParametersCheckOut)
  const rooms = useSelector(getSearchParametersRooms)
  const dispatch = useDispatch()

  const handleCloseButtonClick = () => {
    dispatch(
      trackEvent({
        action: Action.Clicked,
        category: Category.User,
        entity: Entity.BackButton,
        payload: {
          type: 'apAlternativeOffersOverlay'
        }
      })
    )
    closeOverlay()
  }

  const closeOverlay = () => {
    dispatch(setShouldDisplayAlternativeOffers(false))
  }

  useEffect(() => {
    if (isAlternativeOffersOverlayOpen) {
      dispatch(
        trackEvent({
          action: Action.Displayed,
          category: Category.System,
          entity: Entity.AlternativeOffersOverlay
        })
      )
    }
  }, [dispatch, isAlternativeOffersOverlayOpen])

  const isPayAtProperty = false
  return (
    <AlternativeOffersOverlay
      isOpen={isAlternativeOffersOverlayOpen}
      onShadeBackgroundClick={closeOverlay}
      checkIn={checkIn}
      checkOut={checkOut}
      rooms={rooms}
      closeOnOutsideClick={true}
      onClick={handleCloseButtonClick}
      redirectOffersSlot={<AlternativeOffersListContainer />}
      hotelCardSlot={<HotelCardInfoContainer hotel={hotel} />}
      isPayAtProperty={isPayAtProperty}
    />
  )
}
